import { ComponentProps } from 'react';
import { DateRangePickerDay } from '@mui/x-date-pickers-pro';
import { formatDate } from 'app/shared/utils/date';

export const RangePickersDay = (
  props: ComponentProps<typeof DateRangePickerDay>,
) => {
  const { day } = props;
  return <DateRangePickerDay aria-label={formatDate(day)} {...props} />;
};
